module.exports = __webpack_public_path__ + "static/media/ic_rectangle.deb3d8aa.png";